import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    header: 'Question creator',
    headerPreview: 'New question (PREVIEW)',
    fields: {
      type: {
        label: 'Type',
        options: {
          singleChoice: 'Single choice',
          multiChoice: 'Multiple choice',
        },
      },
      yourQuestion: 'Question',
      answerNumber: 'Option {{ n }}',
      numOfOptions: 'Number of options to choose from',
      correctOptions: {
        label: 'Correct options',
        placeholder1: 'select one option ...',
        placeholder2: 'select one or more options ...',
      },
      explanation: {
        label: 'Explanation',
        placeholder:
          'Write some short explanation about the answers for your question ...',
      },
    },
    messages: [
      '- please use English language',
      '- be careful when filling in this form, as you will not be able to edit this data later',
      '- you will see the preview of your new question before adding it',
    ],
  },
}
